(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-base-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ai-base-section')) {
      class AiBaseSection extends HTMLElement {
        constructor() {
          super();
        }
      }
      customElements.define('ai-base-section', AiBaseSection);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-announcebar-flash"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-flash-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-flash-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // close alp-announcebar-flash-close-btn
    document.querySelectorAll('.alp-announcebar-flash-close-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.parentElement.style.display = 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-announcebar-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-3-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-3-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      autoHeight: true,
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-3-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-3-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      autoHeight: true,
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axx-global-compare-full"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', () => {
    class GlobalCompare {
      // checkbox : .global-compare-checkbox with [data-product-id]
      // trigger : [data-global-compare-open] with [data-global-compare-open=' product.id ']
      // options selector : .global-compare-selector
      // options : .global-compare-options with [data-product-id]
      // floating tab: .global-compare-floating-tab

      constructor() {
        // 存储事件处理函数
        this.checkboxs = [];
        this.eventListeners = new Map();
        this.compareParent = document.querySelector('.global-compare');
        this.floatingTab = document.querySelector('.global-compare-floating-tab');
        this.init();
      }

      init() {
        this.removePreloadProducts();
        this.triggerSelectOpen();
        this.updateSelectedProduct();
        this.setSameHeightForItems();
        this.hanldeSelectorChange();
        this.findTheItemsDiff();
        this.triggerOpen();
        this.triggerCompareCheckboxInit();
        this.updateFlotingTabStatus(this.getCookie());
        this.clickFlotingTab();
        window.addEventListener('resize', () => this.setSameHeightForItems());
        window.addEventListener('CompareTrigger', () => this.checkboxEventUpdate());
        this.compareParent.querySelector('.global-compare-diff-trigger').addEventListener('click', () => {
          this.compareParent.classList.toggle('show_diff');
          this.setSameHeightForItems();
        });
      }

      triggerSelectOpen() {
        const globalCompareSelector = document.querySelector('.global-compare-selector span');
        const globalCompareOptions = globalCompareSelector
          .closest('.global-compare-selector')
          .querySelector('.global-compare-options');
        globalCompareSelector.addEventListener('click', () => {
          globalCompareOptions.classList.toggle('hidden');
        });
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.global-compare-selector')) {
            globalCompareOptions.classList.add('hidden');
          }
        });
      }

      updateSelectedProduct() {
        const options = document.querySelectorAll('.global-compare-option');
        options.forEach((option) => {
          option.classList.remove('selected');
        });
        options.forEach((option) => {
          const productId = option.dataset.productId;
          const productEl = this.compareParent.querySelector(
            `.products-new-compare-wrapper [data-product-id="${productId}"]`
          );
          if (productEl) option.classList.add('selected');
        });
      }

      setSameHeightForItems() {
        const rows = document.querySelectorAll(
          '.products-new-compare-wrapper .product-new-compare-i .axx_compare_spec_list'
        );
        const items = rows[0]?.querySelectorAll('.axx_compare_spec_list_item') || [];
        // 重置高度
        rows.forEach((row) => {
          row.querySelectorAll('.axx_compare_spec_list_item').forEach((item) => {
            item.style.setProperty('--height', 'auto');
          });
        });
        // 设置规格高度
        items.forEach((_, index) => {
          let maxHeight = 0;
          rows.forEach((row) => {
            const item = row.querySelectorAll('.axx_compare_spec_list_item')[index];
            maxHeight = Math.max(maxHeight, item.offsetHeight);
          });
          rows.forEach((row) => {
            const item = row.querySelectorAll('.axx_compare_spec_list_item')[index];
            item.style.setProperty('--height', `${maxHeight}px`);
          });
        });
        // 设置图片高度
        const imageWrappers = document.querySelectorAll(
          '.products-new-compare-wrapper .product-new-compare-i .axx-images-with-swatch'
        );
        const maxImageHeight = Math.max(...[...imageWrappers].map((img) => img.offsetHeight), 0);
        imageWrappers.forEach((img) => img.style.setProperty('--height', `${maxImageHeight}px`));
      }

      hanldeSelectorChange() {
        const options = document.querySelectorAll('.global-compare-option');
        options.forEach((option) => {
          option.addEventListener('click', () => {
            const productId = option.dataset.productId;
            option.classList.toggle('selected');
            option.classList.contains('selected') ? this.addProduct(productId) : this.removeProduct(productId);
          });
        });
      }

      removePreloadProducts() {
        this.compareParent
          .querySelectorAll('.products-new-compare-wrapper .product-new-compare-item[data-product-id]')
          .forEach((el) => el.remove());
      }

      async addProduct(ids) {
        // 处理多id输入并去重
        const idArray = Array.isArray(ids)
          ? ids
          : ids
              .toString()
              .split(',')
              .filter((id) => id.trim() !== '');
        const uniqueIds = [...new Set(idArray)];
        const fetchUrl = this.compareParent.dataset.fetchUrl;
        this.compareParent.classList.add('loading');
        // compare ids and the existing products `.product-new-compare-item[data-product-id="${id}"]`
        const existingProducts = this.compareParent.querySelectorAll('.product-new-compare-item[data-product-id]');
        const existingIds = [...existingProducts].map((el) => el.dataset.productId);
        const newIds = uniqueIds.filter((id) => !existingIds.includes(id));
        if (newIds.length === 0) {
          this.compareParent.classList.remove('loading');
          this.compareParent.classList.remove('first-load');
          return;
        }
        // continue to add products
        try {
          const response = await fetch(fetchUrl);
          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceParents = html.querySelectorAll('.products-new-compare-wrapper');
          const targetWrappers = this.compareParent.querySelectorAll('.products-new-compare-wrapper');
          // 遍历每个唯一id添加产品
          uniqueIds.forEach((id) => {
            sourceParents.forEach((sourceEl, index) => {
              const targetEl = targetWrappers[index];
              if (!targetEl) return;
              const exitProductEl = targetEl.querySelector(`.product-new-compare-item[data-product-id="${id}"]`);
              // if (exitProductEl) exitProductEl.remove();
              if (exitProductEl) return;
              const productEl = sourceEl.querySelector(`.product-new-compare-item[data-product-id="${id}"]`);
              if (productEl) targetEl.appendChild(productEl);
              const removeEl = productEl.querySelector('.product-compare-remove');
              if (removeEl) this.handleRemoveProductTrigger(removeEl);
            });
          });
        } finally {
          this.findTheItemsDiff();
          this.updateSelectedProduct();
          this.setSameHeightForItems();
          if (window.axxVariantsSwatch) window.axxVariantsSwatch.update();
          this.compareParent.classList.remove('loading');
          this.compareParent.classList.remove('first-load');
          this.setCookie();
          this.updateCheckboxStatus();
        }
      }

      removeProduct(id) {
        this.compareParent
          .querySelectorAll(`.products-new-compare-wrapper [data-product-id="${id}"]`)
          .forEach((el) => el.remove());
        this.findTheItemsDiff();
        this.updateSelectedProduct();
        this.setSameHeightForItems();
        this.setCookie();
        this.updateCheckboxStatus();
      }

      handleRemoveProductTrigger(el) {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const parent = el.closest('.product-new-compare-item');
          const productId = parent.dataset.productId;
          this.removeProduct(productId);
        });
      }

      setCookie() {
        const uniqueIds = [];
        this.compareParent
          .querySelectorAll('.global-compare-option.selected')
          .forEach((el) => uniqueIds.push(el.dataset.productId));
        // 存储id到cookie（30天过期）
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `selectedIds=${uniqueIds.join(',')}; expires=${expires}; path=/`;
        this.updateFlotingTabStatus(`${uniqueIds.join(',')}`);
      }

      getCookie() {
        // let presetIds = this.compareParent.dataset.presetProducts;
        const cookieValue =
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('selectedIds='))
            ?.split('=')[1] || '';
        if (cookieValue) {
          return cookieValue;
        }
      }

      addIdToCookie(id) {
        let ids = this.getCookie();
        if (!ids) {
          ids = id;
        } else {
          ids = `${ids},${id}`;
        }
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `selectedIds=${ids}; expires=${expires}; path=/`;
        this.updateFlotingTabStatus(ids);
      }

      removeIdFromCookie(id) {
        let ids = this.getCookie();
        if (ids) {
          ids = ids
            .split(',')
            .filter((i) => i !== id)
            .join(',');
          const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = `selectedIds=${ids}; expires=${expires}; path=/`;
          this.updateFlotingTabStatus(ids);
        }
      }

      findTheItemsDiff() {
        document
          .querySelectorAll(
            '.products-new-compare-wrapper.has-compare-data .axx_compare_spec_list .axx_compare_spec_list_item'
          )
          .forEach((item) => {
            item.classList.remove('diff');
          });
        const allRows = document.querySelectorAll(
          '.products-new-compare-wrapper.has-compare-data .axx_compare_spec_list'
        );
        const rows = document.querySelectorAll(
          '.products-new-compare-wrapper.has-compare-data [data-product-id] .axx_compare_spec_list'
        );
        const firstRowItems = rows[0]?.querySelectorAll('.axx_compare_spec_list_item') || [];
        firstRowItems.forEach((_, index) => {
          const values = [...rows].map(
            (row) => row.querySelectorAll('.axx_compare_spec_list_item')[index]?.querySelector('.axcp-desc').textContent
          );
          const hasDiff = new Set(values).size > 1;
          if (hasDiff) {
            allRows.forEach((row) => {
              row.querySelectorAll('.axx_compare_spec_list_item')[index].classList.add('diff');
            });
          }
        });
      }

      triggerCompareCheckboxInit() {
        this.checkboxs = document.querySelectorAll('.global-compare-checkbox');
        if (this.checkboxs.length > 0) {
          this.updateCheckboxStatus();
          this.checkboxs.forEach((checkbox) => {
            const handler = (e) => this.checkboxToggle(checkbox);
            this.eventListeners.set(checkbox, handler);
            checkbox.addEventListener('click', handler);
          });
        }
      }

      checkboxEventUpdate() {
        this.checkboxs.forEach((checkbox) => {
          const handler = this.eventListeners.get(checkbox);
          if (handler) {
            checkbox.removeEventListener('click', handler);
          }
        });
        this.triggerCompareCheckboxInit();
      }

      checkboxToggle(checkbox) {
        const productId = checkbox.dataset.productId;
        if (checkbox.classList.contains('checked')) {
          checkbox.classList.remove('checked');
          this.removeIdFromCookie(productId);
        } else {
          this.addIdToCookie(productId);
        }
        this.updateCheckboxStatus();
      }

      updateCheckboxStatus() {
        let ids = this.getCookie();
        // remove class
        this.checkboxs.forEach((checkbox) => {
          checkbox.classList.remove('checked');
        });
        // update classlist
        if (ids) {
          ids.split(',').forEach((id) => {
            this.checkboxs.forEach((checkbox) => {
              let checkboxId = parseInt(checkbox.dataset.productId);
              if (checkboxId == id) {
                checkbox.classList.add('checked');
              }
            });
          });
          this.updateFlotingTabStatus(ids);
        }
      }

      updateFlotingTabStatus(selectedIds) {
        let floatingTab = this.floatingTab;
        if (!floatingTab) {
          return;
        }
        if (selectedIds) {
          const selectedIdsArray = selectedIds.split(',');
          const selectedIdsCount = selectedIdsArray.length;
          if (selectedIdsCount > 0) {
            floatingTab.classList.add('show');
          } else {
            floatingTab.classList.remove('show');
          }
          floatingTab.querySelector('.compare-products-count').textContent = selectedIdsCount;
        } else {
          floatingTab.classList.remove('show');
        }
      }

      clickFlotingTab() {
        let floatingTab = this.floatingTab;
        if (!floatingTab) {
          return;
        }
        floatingTab.addEventListener('click', (e) => {
          e.preventDefault();
          let ids = this.getCookie() ? this.getCookie() : presetIds;
          if (ids) {
            this.addProduct(ids);
            this.compareParent.classList.remove('hidden');
          }
        });
      }

      triggerOpen() {
        const triggers = document.querySelectorAll('[data-global-compare-open]');
        triggers.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const productId = el.dataset.globalCompareOpen || 'null';
            const productEl = this.compareParent.querySelector(
              `.product-new-compare-item[data-product-id="${productId}"]`
            );
            if (productEl) {
              this.compareParent.classList.remove('hidden');
              this.setSameHeightForItems();
            } else {
              let presetIds = this.compareParent.dataset.presetProducts;
              let ids = this.getCookie() ? this.getCookie() : presetIds;
              if (!ids) {
                ids = productId;
              } else {
                ids = `${ids},${productId}`;
              }
              this.addProduct(ids);
              this.compareParent.classList.remove('hidden');
            }
          });
        });
        const closeTriggers = this.compareParent.querySelectorAll('.global-compare-close, .global-compare-overlay');
        closeTriggers.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.compareParent.classList.add('hidden');
          });
        });
      }
    }

    window.axxGlobalCompare = new GlobalCompare();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axx-page-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-list-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    $('.faq-new-box .container-pc .faq-box .faq-item .title').click(function () {
      let $this = $(this).parent();
      $this.toggleClass('active').siblings().removeClass('active');
      $this.find('.faq-new-box .container-pc .faq-box .faq-item .faq-list').slideToggle(400);
      $this.siblings().find('.faq-new-box .container-pc .faq-box .faq-item .faq-list').slideUp(400);
    });

    // FAQ折叠功能（事件委托）
    const faqList = document.querySelectorAll('.container-pc .faq-box .faq-item .faq-list');
    faqList.forEach((list) => {
      list.addEventListener('click', (e) => {
        const quest = e.target.closest('.quest');
        if (quest) {
          quest.closest('.item').classList.toggle('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-new"] && !Shopify.designMode) return;
  try {
    
  const initFaqNew = (rootDom) => {
    if (!rootDom || rootDom.dataset.faqNewInitialized === 'true') return;
    rootDom.dataset.faqNewInitialized = 'true';

    const searchInput = rootDom.querySelector('.search-input');
    const menuItemList = Array.from(rootDom.querySelectorAll('.container-pc .menu .menu-item'));
    const faqItemList = Array.from(rootDom.querySelectorAll('.container-pc .faq-box .faq-item'));
    const faqItemListReverse = [...faqItemList].reverse();
    const popTips = rootDom.querySelector('.pop-tips');
    const popTipsContent = rootDom.querySelector('.pop-tips .content');
    const searchPlaceholderSpan = rootDom.querySelector('.search-box .placeholder span');
    const searchPlaceholderIcon = rootDom.querySelector('.search-box .placeholder svg');
    const searchResultsTemplate = rootDom.dataset.searchResultsText || 'Es wurden {count} Ergebnisse gefunden';

    let activeTag = 0;
    let inputTimer = null;
    let hideTipsTimer = null;
    let menuSwiper = null;

    const menuEl = rootDom.querySelector('.menu');
    if (menuEl && typeof Swiper !== 'undefined') {
      menuSwiper = new Swiper(menuEl, {
        slidesPerView: 'auto',
      });
    }

    const setActiveTag = (index) => {
      if (!menuItemList.length || index < 0 || index >= menuItemList.length || index === activeTag) return;

      menuItemList[activeTag]?.classList.remove('active');
      menuItemList[index].classList.add('active');
      menuSwiper?.slideTo(index);
      activeTag = index;
    };

    const isContain = (el) => {
      const rect = el.getBoundingClientRect();
      const vWidth = window.innerWidth || document.documentElement.clientWidth;
      const vHeight = window.innerHeight || document.documentElement.clientHeight;

      return !(rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight);
    };

    const showSearchTips = (count) => {
      if (!popTips || !popTipsContent) return;

      popTipsContent.textContent = searchResultsTemplate.replace('{count}', count);
      popTips.hidden = false;
      popTips.classList.remove('pop-tips-hide');
      popTips.classList.add('pop-tips-show');

      clearTimeout(hideTipsTimer);
      hideTipsTimer = setTimeout(() => {
        popTips.classList.remove('pop-tips-show');
        popTips.classList.add('pop-tips-hide');
        setTimeout(() => {
          popTips.classList.remove('pop-tips-hide');
          popTips.hidden = true;
        }, 500);
      }, 5000);
    };

    const searchTitle = (keywords) => {
      const normalizedKeywords = keywords.trim().toLowerCase();
      let activeNum = 0;

      rootDom.querySelectorAll('.container-pc .faq-box .faq-item .faq-list .item').forEach((item) => {
        const title = item.querySelector('.quest')?.innerText.toLowerCase() || '';
        const matched = normalizedKeywords !== '' && title.includes(normalizedKeywords);

        item.classList.toggle('search-actie', matched);
        item.classList.toggle('show-none', normalizedKeywords !== '' && !matched);

        if (matched) activeNum += 1;
      });

      if (activeNum > 0) {
        showSearchTips(activeNum);
      }
    };

    const updateSearchPlaceholder = (hasValue) => {
      if (searchPlaceholderSpan) {
        searchPlaceholderSpan.style.height = hasValue ? '0' : 'auto';
      }
      if (searchPlaceholderIcon) {
        searchPlaceholderIcon.style.display = hasValue ? 'none' : 'block';
      }
    };

    searchInput?.addEventListener('input', () => {
      clearTimeout(inputTimer);
      updateSearchPlaceholder(searchInput.value !== '');

      inputTimer = setTimeout(() => {
        searchTitle(searchInput.value);
      }, 500);
    });

    menuItemList.forEach((item, index) => {
      item.addEventListener('click', () => {
        setActiveTag(index);
      });
    });

    let scrollTick = 0;
    document.addEventListener('scroll', () => {
      if (!faqItemListReverse.length || !menuItemList.length) return;
      if (scrollTick++ % 3 !== 0) return;

      let activeFlag = -1;
      faqItemListReverse.forEach((item, index) => {
        if (isContain(item)) {
          activeFlag = faqItemList.length - index - 1;
        }
      });

      if (activeFlag >= 0) {
        setActiveTag(activeFlag);
      }
    });

    rootDom.querySelectorAll('.container-pc .faq-box .faq-item .faq-list').forEach((list) => {
      list.addEventListener('click', (event) => {
        const quest = event.target.closest('.quest');
        if (quest) {
          quest.closest('.item')?.classList.toggle('active');
        }
      });
    });

    if (typeof $ !== 'undefined') {
      $(rootDom)
        .find('.container-pc .faq-box .faq-item .title')
        .on('click', function () {
          const $item = $(this).parent();
          $item.toggleClass('active');
          // $item.find('.faq-list').slideToggle(400);
          // $item.siblings().find('.faq-list').slideUp(400);
        });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq-new-box').forEach(initFaqNew);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-product-sticky-banner"] && !Shopify.designMode) return;
  try {
    
  class LXProductStickyBanner extends HTMLElement {
    constructor() {
      super();
      this._syncingQuantity = false;
      this._lastScrollY = window.scrollY;
      this._headerHidden = false;
      this._onScroll = this.handleScroll.bind(this);
      this._onTabClick = this.handleTabClick.bind(this);
      this._onAddToCartClick = this.handleAddToCartClick.bind(this);
      this._onBannerQuantityChange = this.handleBannerQuantityChange.bind(this);
      this._onFormQuantityChange = this.handleFormQuantityChange.bind(this);
      this._onProductDetailUpdated = this.handleProductDetailUpdated.bind(this);
      this._onFormLoadingChange = this.handleFormLoadingChange.bind(this);
      this._syncTopHeight = this.syncTopHeight.bind(this);
    }

    connectedCallback() {
      this.productDetailEl = document.querySelector('[data-product-detail]');
      this.productFormEl = document.querySelector('form.lx-product-form');
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.addToCartBtn = this.querySelector('[data-product-sticky-banner-add-to-cart]');

      this.querySelectorAll('.lx-product-sticky-banner__tab[data-target]').forEach((tab) => {
        tab.addEventListener('click', this._onTabClick);
      });

      this.addToCartBtn?.addEventListener('click', this._onAddToCartClick);
      this.bindQuantityListeners();

      this.productDetailEl?.addEventListener(
        'lx-variant-selector-v1:product-detail-updated',
        this._onProductDetailUpdated
      );

      //   this.productFormEl?.addEventListener('submit', this._onFormLoadingChange);
      document.addEventListener('lx-add-to-cart:finished', this._onFormLoadingChange);

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._syncTopHeight);
      this.bindTopHeightObserver();
      this.handleScroll();
      this.syncQuantityFromForm();
    }

    disconnectedCallback() {
      this.querySelectorAll('.lx-product-sticky-banner__tab[data-target]').forEach((tab) => {
        tab.removeEventListener('click', this._onTabClick);
      });

      this.addToCartBtn?.removeEventListener('click', this._onAddToCartClick);
      this.unbindQuantityListeners();

      this.productDetailEl?.removeEventListener(
        'lx-variant-selector-v1:product-detail-updated',
        this._onProductDetailUpdated
      );

      //   this.productFormEl?.removeEventListener('submit', this._onFormLoadingChange);
      document.removeEventListener('lx-add-to-cart:finished', this._onFormLoadingChange);

      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._syncTopHeight);
      this.unbindTopHeightObserver();
      this.setHeaderHidden(false);
    }

    bindTopHeightObserver() {
      this.unbindTopHeightObserver();
      this.topEl = this.querySelector('.lx-product-sticky-banner__top');

      if (!this.topEl) {
        this.syncTopHeight();
        return;
      }

      if (typeof ResizeObserver !== 'undefined') {
        this._topResizeObserver = new ResizeObserver(this._syncTopHeight);
        this._topResizeObserver.observe(this.topEl);
      }

      this.syncTopHeight();
    }

    unbindTopHeightObserver() {
      this._topResizeObserver?.disconnect();
      this._topResizeObserver = null;
    }

    syncTopHeight() {
      const topEl = this.querySelector('.lx-product-sticky-banner__top');
      const sectionEl = this.closest('.shopify-section.lx-product-sticky-banner');

      if (!topEl) {
        this.style.removeProperty('height');
        this.style.removeProperty('--lx-product-sticky-banner-top-height');
        sectionEl?.style.removeProperty('height');
        return;
      }

      const height = Math.ceil(topEl.getBoundingClientRect().height);
      if (height <= 0) return;

      const heightValue = `${height}px`;
      this.style.setProperty('--lx-product-sticky-banner-top-height', heightValue);
      this.style.height = heightValue;
      sectionEl?.style.setProperty('height', heightValue);
    }

    bindQuantityListeners() {
      this.unbindQuantityListeners();
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.bannerQuantityEl?.addEventListener('change', this._onBannerQuantityChange);
      this.bannerQuantityEl?.addEventListener('input', this._onBannerQuantityChange);
      this.formQuantityEl?.addEventListener('change', this._onFormQuantityChange);
      this.formQuantityEl?.addEventListener('input', this._onFormQuantityChange);
    }

    unbindQuantityListeners() {
      this.bannerQuantityEl?.removeEventListener('change', this._onBannerQuantityChange);
      this.bannerQuantityEl?.removeEventListener('input', this._onBannerQuantityChange);
      this.formQuantityEl?.removeEventListener('change', this._onFormQuantityChange);
      this.formQuantityEl?.removeEventListener('input', this._onFormQuantityChange);
    }

    getScrollOffset() {
      return Number(this.dataset.scrollOffset || 32);
    }

    parseCssLength(value) {
      const num = parseFloat(String(value || '').trim());
      return Number.isFinite(num) ? num : 0;
    }

    getCssVar(name) {
      const bodyValue = getComputedStyle(document.body).getPropertyValue(name);
      if (bodyValue) return this.parseCssLength(bodyValue);

      return this.parseCssLength(getComputedStyle(document.documentElement).getPropertyValue(name));
    }

    getHeaderBarOffset() {
      // if (this._headerHidden) return 0;

      const barEl = document.querySelector('.shopify-section.alp-announcement-bar-section');
      const headerEl = document.querySelector('.shopify-section.alp-header-section');
      const barHeight = barEl?.offsetHeight || this.getCssVar('--bar-height');
      const headerHeight = headerEl?.offsetHeight || this.getCssVar('--header-height');

      return barHeight + headerHeight;
    }

    getHeaderOffset() {
      const bannerHeight =
        this.querySelector('.lx-product-sticky-banner__wrapper .lx-product-sticky-banner__top')?.offsetHeight || 0;
      return this.getHeaderBarOffset() + bannerHeight + this.getScrollOffset();
    }

    isBannerAtTop() {
      if (!this.classList.contains('is-visible')) return false;

      const topBar = this.querySelector('.lx-product-sticky-banner__top');
      if (!topBar) return false;

      const expectedTop = this.getHeaderBarOffset();
      const topBarTop = topBar.getBoundingClientRect().top;

      return topBarTop <= expectedTop + 8;
    }

    getHeaderElements() {
      return {
        bar: document.querySelector('.shopify-section.alp-announcement-bar-section'),
        header: document.querySelector('.shopify-section.alp-header-section'),
        section: document.querySelector('.shopify-section.lx-product-sticky-banner'),
      };
    }

    setHeaderHidden(hidden) {
      const nextHidden = Boolean(hidden);
      if (this._headerHidden === nextHidden) return;

      this._headerHidden = nextHidden;
      this.classList.toggle('is-header-hidden', nextHidden);
      document.documentElement.classList.add('lx-sticky-banner-header-transition');
      document.documentElement.classList.toggle('lx-sticky-banner-header-hidden', nextHidden);

      const { bar, header, section } = this.getHeaderElements();

      if (nextHidden) {
        // bar?.style.setProperty('opacity', '0');
        // bar?.style.setProperty('pointer-events', 'none');
        // header?.style.setProperty('opacity', '0');
        // header?.style.setProperty('pointer-events', 'none');
        // section?.style.setProperty('top', '0');
      } else {
        // bar?.style.removeProperty('opacity');
        // bar?.style.removeProperty('pointer-events');
        // header?.style.removeProperty('opacity');
        // header?.style.removeProperty('pointer-events');
        section?.style.removeProperty('top');
      }
    }

    updateHeaderOnScrollDirection() {
      const currentScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      const scrollDelta = currentScrollY - this._lastScrollY;

      if (!this.classList.contains('is-visible')) {
        this.setHeaderHidden(false);
        this._lastScrollY = currentScrollY;
        return;
      }

      if (!this.isBannerAtTop()) {
        if (scrollDelta < -4) {
          this.setHeaderHidden(false);
        }
        this._lastScrollY = currentScrollY;
        return;
      }

      if (scrollDelta > 4) {
        this.setHeaderHidden(true);
      } else if (scrollDelta < -4) {
        this.setHeaderHidden(false);
      }

      this._lastScrollY = currentScrollY;
    }

    handleScroll() {
      const productDetail = this.productDetailEl || document.querySelector('[data-product-detail]');
      const mainContent = document.querySelector('main#MainContent');

      if (!productDetail || !mainContent) {
        this.classList.remove('is-visible');
        this.setHeaderHidden(false);
        return;
      }

      const productTop = productDetail.offsetTop + productDetail.offsetHeight;
      const mainBottom = mainContent.offsetTop + mainContent.offsetHeight;
      const shouldShow = window.scrollY > productTop + 0 && window.scrollY < mainBottom - 80;
      const shouldShowBottom = window.scrollY > productTop && window.scrollY < mainBottom - 20;

      this.classList.toggle('is-visible', shouldShow);
      this.classList.toggle('is-visible-bottom', shouldShowBottom);

      if (!shouldShow) {
        this.setHeaderHidden(false);
      }

      this.updateHeaderOnScrollDirection();
      this.updateActiveTab();
    }

    resolveTargetElement(tab) {
      const selector = tab?.dataset?.target;
      const targetId = tab?.dataset?.targetId;

      if (selector) {
        const bySelector = document.querySelector(selector);
        if (bySelector) return bySelector;
      }

      if (targetId) {
        const byHandle = document.querySelector(`[data-section-handle="${targetId}"]`);
        if (byHandle) return byHandle;

        if (window.CSS?.escape) {
          return document.querySelector(`#${CSS.escape(targetId)}`);
        }

        return document.getElementById(targetId);
      }

      return null;
    }

    getTargetTop(targetEl) {
      return targetEl.getBoundingClientRect().top + window.scrollY;
    }

    updateActiveTab() {
      const tabs = [
        ...this.querySelectorAll(
          '.lx-product-sticky-banner__tab[data-target], .lx-product-sticky-banner__tab[data-target-id]'
        ),
      ];
      if (!tabs.length) return;

      const scrollLine = window.scrollY + this.getHeaderOffset();
      let activeTab = null;

      const entries = tabs
        .map((tab) => {
          const targetEl = this.resolveTargetElement(tab);
          if (!targetEl) return null;
          return { tab, top: this.getTargetTop(targetEl) };
        })
        .filter(Boolean)
        .sort((a, b) => a.top - b.top);

      for (const entry of entries) {
        if (scrollLine >= entry.top) {
          activeTab = entry.tab;
        }
      }

      tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab === activeTab);
      });
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const targetEl = this.resolveTargetElement(tab);
      if (!targetEl) return;

      this.querySelectorAll('.lx-product-sticky-banner__tab').forEach((item) => {
        item.classList.toggle('is-active', item === tab);
      });

      const targetTop = this.getTargetTop(targetEl) - this.getHeaderOffset() + 2;
      window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
    }

    handleBannerQuantityChange() {
      if (this._syncingQuantity) return;
      this.syncQuantityToForm();
    }

    handleFormQuantityChange() {
      if (this._syncingQuantity) return;
      this.syncQuantityFromForm();
    }

    syncQuantityFromForm() {
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');

      if (!this.formQuantityEl || !this.bannerQuantityEl) return;

      this.copyQuantityRules(this.formQuantityEl, this.bannerQuantityEl);

      if (this.formQuantityEl.value !== this.bannerQuantityEl.value) {
        this._syncingQuantity = true;
        this.bannerQuantityEl.value = this.formQuantityEl.value;
        this._syncingQuantity = false;
      }

      this.bannerQuantityEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncQuantityToForm() {
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');

      if (!this.formQuantityEl || !this.bannerQuantityEl) return;
      if (this.formQuantityEl.value === this.bannerQuantityEl.value) return;

      this._syncingQuantity = true;
      this.formQuantityEl.value = this.bannerQuantityEl.value;
      this.formQuantityEl.dispatchEvent(new Event('change', { bubbles: true }));
      this._syncingQuantity = false;
    }

    copyQuantityRules(fromInput, toInput) {
      ['min', 'max', 'step', 'data-lx-qty-min', 'data-lx-qty-max', 'data-lx-qty-step'].forEach((attr) => {
        if (fromInput.hasAttribute(attr)) {
          toInput.setAttribute(attr, fromInput.getAttribute(attr));
        } else {
          toInput.removeAttribute(attr);
        }
      });
    }

    handleAddToCartClick() {
      if (!this.productFormEl || this.addToCartBtn?.disabled) return;

      this.syncQuantityToForm();
      this.addToCartBtn?.classList.add('is-loading');

      const submitButton = this.productFormEl.querySelector('[data-lx-add-to-cart-button], [type="submit"]');
      submitButton?.click();
    }

    handleFormLoadingChange() {
      setTimeout(() => {
        const isLoading = this.productFormEl?.classList.contains('loading');
        if (!isLoading) {
          this.addToCartBtn?.classList.remove('is-loading');
        }
      }, 200);
    }

    handleProductDetailUpdated(event) {
      const { html, variant } = event.detail || {};
      const sectionRoot = this.closest('[data-stid]');
      const sectionId = sectionRoot?.dataset?.stid;

      let nextBanner = null;
      if (sectionId && html) {
        nextBanner =
          html.querySelector(`[data-stid="${sectionId}"] lx-product-sticky-banner`) ||
          html.querySelector(`[data-stid="${sectionId}"] .lx-product-sticky-banner`);
      }
      nextBanner = nextBanner || html?.querySelector('lx-product-sticky-banner');

      if (nextBanner) {
        this.replaceElement('[data-product-sticky-banner-element="image"]', nextBanner);
        this.replaceElement('[data-product-sticky-banner-element="variant-title"]', nextBanner);
        this.replaceElement('[data-product-sticky-banner-element="price"]', nextBanner);
        this.replaceElement('[data-product-sticky-banner-element="quantity"]', nextBanner);
      } else if (variant) {
        this.updatePrice(variant);
        this.updateVariantTitle(variant);
      }

      if (variant) {
        this.dataset.variantId = String(variant.id);
        this.dataset.variantAvailable = String(variant.available);
        this.updateAddButton(variant);
        this.updateVariantTitle(variant);
      } else {
        this.updateAddButton(null);
      }

      this.bindQuantityListeners();
      this.syncQuantityFromForm();
    }

    replaceElement(selector, sourceRoot) {
      const currentEl = this.querySelector(selector);
      const nextEl = sourceRoot.querySelector(selector);
      if (!currentEl) return;

      if (!nextEl) {
        if (selector.includes('variant-title')) {
          currentEl.classList.add('hidden');
          currentEl.textContent = '';
        }
        return;
      }

      currentEl.innerHTML = nextEl.innerHTML;
      currentEl.className = nextEl.className;
    }

    updatePrice(variant) {
      const priceEl = this.querySelector('[data-product-sticky-banner-element="price"]');
      if (!priceEl || !variant) return;

      const currency = Shopify.currency.active;
      const language = `${Shopify.locale}-${Shopify.country}`;

      const priceNode = priceEl.querySelector('[data-product-price]');
      const compareNode = priceEl.querySelector('[data-product-compare-price]');

      if (priceNode && variant.price != null) {
        priceNode.textContent = (variant.price / 100).toLocaleString(language, {
          style: 'currency',
          currency,
        });
        priceNode.classList.toggle(
          'lx-product-sticky-banner__price-value--sale',
          variant.compare_at_price > variant.price
        );
      }

      if (compareNode) {
        if (variant.compare_at_price > variant.price) {
          compareNode.textContent = (variant.compare_at_price / 100).toLocaleString(language, {
            style: 'currency',
            currency,
          });
          compareNode.classList.remove('hidden');
        } else {
          compareNode.classList.add('hidden');
        }
      }
    }

    updateVariantTitle(variant) {
      const variantTitleEl = this.querySelector('[data-product-sticky-banner-element="variant-title"]');
      if (!variantTitleEl) return;

      const title = variant?.title?.trim();
      if (!title || title === 'Default Title') {
        variantTitleEl.classList.add('hidden');
        variantTitleEl.textContent = '';
        return;
      }

      variantTitleEl.textContent = title;
      variantTitleEl.classList.remove('hidden');
    }

    updateAddButton(variant) {
      const textEl = this.addToCartBtn?.querySelector('.lx-product-sticky-banner__add-to-cart-text');
      const available = Boolean(variant?.available);

      if (!this.addToCartBtn) return;

      this.addToCartBtn.disabled = !available;
      if (available) {
        this.addToCartBtn.removeAttribute('aria-disabled');
      } else {
        this.addToCartBtn.setAttribute('aria-disabled', 'true');
      }

      if (textEl) {
        textEl.textContent = available
          ? window.variantStrings?.addToCart || 'Add to cart'
          : window.variantStrings?.soldOut || 'Sold out';
      }
    }
  }

  if (!customElements.get('lx-product-sticky-banner')) {
    customElements.define('lx-product-sticky-banner', LXProductStickyBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
